import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    themeCssClass: 'foodkuy-red',
    dadosEstabelecimento: null,
    configuracoes: null
  },

  actions: {},

  mutations: {
    UPDATE_THEME(state, themeCssClass) {
      state.themeCssClass = themeCssClass
    },

    UPDATE_DADOS_ESTABELECIMENTO(state, dadosEstabelecimento) {
      state.dadosEstabelecimento = dadosEstabelecimento
    },

    UPDATE_CONFIGURACOES(state, configuracoes) {
      state.configuracoes = configuracoes
    }
  },

  modules: {}
})